<template>
  <div>
    <b-modal
      ref="modal"
      id="modal-no-backdrop"
      hide-backdrop
      content-class="shadow"
      :title="'Confirma o cancelamento da Transação?'"
    >
      <div class="container-fluid">
        <div class="row"></div>
        <br />
        <div class="row">
          <div class="col-12">
            <h5>Lançamento no caixa referente:</h5>
            <br />
            <h4>{{ transactions.description }}</h4>
          </div>
        </div>
        <br />
      </div>

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Não Cancelar
        </button>
        <button
          role="button"
          class="btn btn-danger"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Cancelar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Filters from "../../../mixins/Filters.js";
import Form from "../../../mixins/Form.js";

export default {
  data: function () {
    return {
      transactions: {},
    };
  },
  methods: {
    open(transactions) {
      this.transactions = transactions;
      this.$refs.modal.show();
    },

    store() {
      this.$store.commit("showLoading");
      this.$store
        .dispatch(
          "accountTransaction/destroyAccountTransaction",
          this.transactions.id
        )
        .then((response) => {
          this.$emit("cancelled");

          this.$refs.modal.hide();
        })
        .catch((error) => {
          this.$store.commit("hideLoading");

          this.error = error;
        });
    },
  },
};
</script>

<style>
</style>
